export default __webpack_public_path__ + "static/rationalizaion-5c8096ef2e9cec5543de77b294b14061.jpg";